'use client'

import Section from 'components/Section'
import { Typography, MediaImageStandard } from 'components/Contentful'

const createImageContent = (src) => ({
  fields: {
    file: {
      url: src,
      fileName: 'words-from-leadership-image',
    },
  },
})

function WordsFromLeadership(content) {
  const jsonContent =
    content?.content?.fields?.sectionContents?.find(
      (section) => section?.fields?.uiComponent === 'JsonContent'
    )?.fields?.jsonContent ||
    content?.content?.jsonContent ||
    content?.jsonContent

  if (!jsonContent) return null

  const { image, quoteName, quoteTitle, quoteText, title, invertLayout } = jsonContent

  return (
    <Section
      disableGutters
      className="pt-[48px] breakpointMd:pt-[80px] pb-[48px] breakpointMd:pb-[80px] breakpointMd:px-[32px]"
    >
      <div className="grid grid-cols-4 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 gap-4 breakpointMd:gap-6 breakpointLg:gap-8">
        {/* Wrapper: flex-col on mobile/mid (no gap), display:contents on desktop so both boxes sit in grid */}
        <div className="col-span-full breakpointLg:contents flex flex-col">
          {/* Right box — top on mobile/mid */}
          <div
            className={`breakpointLg:col-span-6 ${
              invertLayout ? 'breakpointLg:order-1' : 'breakpointLg:order-2'
            } flex flex-col justify-center items-center py-[48px] breakpointMd:py-[64px] breakpointLg:py-[195px] px-[20px] breakpointMd:px-[32px] breakpointLg:px-0 bg-[#2C47F6] rounded-t-[32px] rounded-b-none breakpointLg:rounded-[32px]`}
          >
            {title && (
              <Typography
                content={title}
                className="font-ultramarine text-[32px] leading-[130%] breakpointMd:text-[52px] breakpointMd:leading-[120%] font-bold text-[#F8F9FC] text-left breakpointLg:text-center breakpointLg:px-[64px]"
              />
            )}
          </div>
          {/* Left box — bottom on mobile/mid */}
          <div
            className={`breakpointLg:col-span-6 ${
              invertLayout ? 'breakpointLg:order-2' : 'breakpointLg:order-1'
            } flex flex-col justify-center items-center py-[48px] breakpointMd:py-[64px] px-[20px] breakpointMd:px-[32px] breakpointLg:px-[64px] bg-[#F8F9FC] rounded-b-[32px] rounded-t-none breakpointLg:rounded-[32px]`}
          >
            {quoteText && (
              <Typography
                content={`"${quoteText}"`}
                className="font-ultramarine text-[18px] leading-[155%] breakpointMd:text-[24px] breakpointMd:leading-[140%] font-normal text-[#1D252F]"
              />
            )}
            {(image || quoteName || quoteTitle) && (
              <div className="flex flex-row items-center gap-[8px] mt-[16px] self-start">
                {image && (
                  <div className="w-[72px] h-[72px] rounded-full overflow-hidden shrink-0">
                    <MediaImageStandard
                      content={createImageContent(image)}
                      alt={quoteName || 'leadership'}
                      width={72}
                      height={72}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className="flex flex-col">
                  {quoteName && (
                    <Typography
                      content={quoteName}
                      className="font-ultramarine text-[18px] font-bold leading-[140%] text-[#1D252F]"
                    />
                  )}
                  {quoteTitle && (
                    <Typography
                      content={quoteTitle}
                      className="mt-[4px] font-ultramarine text-[18px] font-normal leading-[140%] text-[#1D252F]"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default WordsFromLeadership
